// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.listings.HpApiListingsV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApiResponseDto, HpListingDetailResponseDto, HpPriceHistoryResponseDto, ListingAlias } from '../..';

interface DetailParams {
  includeBuildingReview?: boolean;
  includeReviews?: boolean;
  maloneLotIdEncoded: string;
  unit?: string;
}
interface PriceHistoryParams {
  listingAlias: ListingAlias;
  modelId: string;
}

export const HpApiListingsV3Handler_detail_Path = '/api/web/v3/listings/detail';

/**
 * Returns building/listing detail by malone lot id
 */
export const HpApiListingsV3Handler_detail = (getParams: DetailParams, client = getClient()) => {
  return httpApiRequest<DetailParams, never, HpApiResponseDto<HpListingDetailResponseDto>>(
    {
      getParams: getParams,
      endpoint: HpApiListingsV3Handler_detail_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiListingsV3Handler_priceHistory_Path = '/api/web/v3/listings/priceHistory';

/**
 * Returns rental price history for an exact listing model
 */
export const HpApiListingsV3Handler_priceHistory = (getParams: PriceHistoryParams, client = getClient()) => {
  return httpApiRequest<PriceHistoryParams, never, HpApiResponseDto<HpPriceHistoryResponseDto>>(
    {
      getParams: getParams,
      endpoint: HpApiListingsV3Handler_priceHistory_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};
